<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Pick List" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Pick List</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" v-show="!processMode" @click="processModeInit" icon="done">Process</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" v-show="processMode" @click="sendMovementOrders(true)" icon="done">Confirm Movement Orders</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" v-show="processMode" @click="sendMovementOrders(false)" icon="cancel">Cancel Movement Orders</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" v-show="processMode" @click="processMode = false" icon="cancel">Cancel Process</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="checkItem" icon="assignment_turned_in">Check</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="printModal = true" icon="print">Print</vs-button>
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Picker
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.picker" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Status
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.status.name" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Created At
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.created_at" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
            <vs-card class="p-4">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <h4>Pick Lists <small>- {{ processMode ? processTitle : viewTitle }}</small></h4>
                </div>
                <div style="overflow-y: auto;">
                    <vs-table
                        :multiple="processMode"
                        v-model="selected"
                        :data="!processMode ? data.details : data.open"
                    >
                        <template slot="thead">
                            <vs-th>Line ID</vs-th>
                            <vs-th>OD Reference</vs-th>
                            <vs-th>Product</vs-th>
                            <vs-th>Pack ID</vs-th>
                            <vs-th>Batch</vs-th>
                            <vs-th>Exp. Date</vs-th>
                            <vs-th>Qty</vs-th>
                            <vs-th>UoM</vs-th>
                            <vs-th>Location</vs-th>
                            <vs-th>Storage Unit</vs-th>
                            <vs-th>Status</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="data[indextr].mo_detail.status_id == 1 ? null : (data[indextr].mo_detail.status_id == 2 ? 'success' : 'danger')">
                                <vs-td :data="indextr + 1">
                                    {{indextr + 1}}
                                </vs-td>
                                <vs-td :data="data[indextr].mo_detail.gr_reference">
                                    {{data[indextr].mo_detail.gr_reference}}
                                </vs-td>
                                <vs-td :data="data[indextr].mo_detail.product.product_code">
                                    {{data[indextr].mo_detail.product.product_code}}
                                </vs-td>
                                <vs-td :data="data[indextr].pack_id">
                                    {{data[indextr].pack_id}}
                                </vs-td>
                                <vs-td :data="data[indextr].batch">
                                    {{data[indextr].batch}}
                                </vs-td>
                                <vs-td :data="data[indextr].expired_date">
                                    {{data[indextr].expired_date}}
                                </vs-td>
                                <vs-td :data="data[indextr].mo_detail.base_qty">
                                    {{data[indextr].mo_detail.base_qty}}
                                </vs-td>
                                <vs-td :data="data[indextr].mo_detail.base_uom.name">
                                    {{data[indextr].mo_detail.base_uom.name}}
                                </vs-td>
                                <vs-td :data="data[indextr].mo_detail.source_location.location_code">
                                    {{data[indextr].mo_detail.source_location.location_code}}
                                </vs-td>
                                <vs-td :data="data[indextr].mo_detail.source_storage_unit">
                                    {{data[indextr].mo_detail.source_storage_unit}}
                                </vs-td>
                                <vs-td :data="data[indextr].mo_detail.mo_statuses.name">
                                    {{data[indextr].mo_detail.mo_statuses.name}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </vs-card>
            <vs-prompt
                title="Print Type"
                accept-text="Print"
                @accept="printPickList"
                :active.sync="printModal">
                <div class="con-exemple-prompt">
                    <vs-select
                        class="selectExample"
                        v-model="printType"
                        width="100%"
                    >
                        <vs-select-item value="label" text="Label (RF Picking)"/>
                        <vs-select-item value="paper" text="Paper (Manual Picking)"/>
                    </vs-select>
                </div>
            </vs-prompt>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                isLoading: false,
                data: {
                    picker: '',
                    status: {
                        name: '',
                    },
                    created_at: '',
                    details: [],
                    open: []
                },
                maxRetry: 10,
                printModal: false,
                printType: "label",
                selected: [],
                processMode: false,
                processTitle: '',
                viewTitle: ''
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            back() {
                this.$router.go(-1)
            },
            fetchAllData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                Promise.all([this.$http.get('pick/pick_list/' + this.$route.params.id)])
                .then(this.$http.spread((picklist) => {
                    this.data = picklist.data
                    this.data.open = []
                    picklist.data.details.map(item => {
                        if(item.mo_detail.status_id == 1) {
                            this.data.open.push(item)
                        }
                    })
                    this.processTitle = this.data.open.length + ' open movement order(s)'
                    this.viewTitle = this.data.details.length + ' pick list detail(s)'
                    this.data.picker = picklist.data.picker ? picklist.data.picker.username : ''
                }))
                .catch(() => {
                    if(this.maxRetry < 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.fetchAllData()
                                this.maxRetry = 10
                            },
                            cancel: () => this.$router.push({name: 'pick-list'}),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        })
                        return;
                    }
                    this.fetchAllData()
                })
                .then(() => this.isLoading = false)
            },
            printPickList() {
                this.isLoading = true
                const id = [this.$route.params.id]
                this.$http.post('pick/pick_list/print/' + this.printType, {id: id}, { responseType: 'blob' })
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .then(() => this.isLoading = false)
            },
            processModeInit() {
                this.selected = []
                this.processMode = true
            },
            sendMovementOrders(confirm) {
                const mo_id = []
                this.selected.map(item => {
                    mo_id.push({
                        id: item.mo_detail_id
                    })
                })

                if(mo_id.length < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected'
                    })
                }
                else {
                    this.isLoading = true
                    if(confirm) {
                        this.$http.post('putaway/confirmputaway', {'list_putaway': JSON.stringify(mo_id)})
                        .then(res => {
                            this.isLoading = false
                            this.$vs.notify({
                                color: 'success',
                                title: 'Success',
                                iconPack: 'feather',
                                icon:'icon-check',
                                text: 'Confirmed successfully'
                            })
                            this.removeOpen(mo_id)
                        })
                        .catch(error => {
                            this.isLoading = false
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error saving',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: error.response.data
                            })
                        })
                    }
                    else {
                        this.$http.post('putaway/cancelputaway', {'list_putaway': JSON.stringify(mo_id)})
                        .then(res => {
                            this.isLoading = false
                            this.$vs.notify({
                                color: 'success',
                                title: 'Success',
                                iconPack: 'feather',
                                icon:'icon-check',
                                text: 'Cancelled successfully'
                            })
                            this.removeOpen(mo_id)
                        })
                        .catch(error => {
                            this.isLoading = false
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error saving',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: error.response.data
                            })
                        })
                    }
                }
            },
            removeOpen(ids) {
                ids.map(id => {
                    this.data.open.map((open, index) => {
                        if(id.id == open.mo_detail_id) {
                            this.data.open.splice(index, 1)
                        }
                    })
                })

                this.selected = []
            },
            checkItem() {
                if(this.data.status.id != 3) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon: 'icon-x',
                        text: 'Picking is not completed!'
                    })
                }
                else {
                    this.$router.push({
                        name: 'pick-list-check',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                }
            }
        },
        mounted(){
            if(!this.$route.params.id) {
                this.$router.push({name: 'pick-list'})
            }
            else {
                this.fetchAllData()
            }
        },
	}
</script>